
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/configuration",
      function () {
        return require("private-next-pages/configuration.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/configuration"])
      });
    }
  